module.exports = __webpack_public_path__ + "static/media/neck2.66922ec3.png";